// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"260":"publishers","687":"agenda","797":"event"}[chunkId] + "." + {"260":"b11798e9","687":"ee5ca2fd","797":"2b0c1a3a"}[chunkId] + ".css";
};